var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQPauseFilled = function SvgQPauseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.7,
    height: 8.555,
    x: 8.497,
    y: 7.722,
    fill: "#fff",
    rx: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7,
    height: 8.555,
    x: 13.803,
    y: 7.722,
    fill: "#fff",
    rx: 0.85
  })));
};
export { SvgQPauseFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjIgMTJDMjIgMTcuNTIyOCAxNy41MjI4IDIyIDEyIDIyQzYuNDc3MTUgMjIgMiAxNy41MjI4IDIgMTJDMiA2LjQ3NzE1IDYuNDc3MTUgMiAxMiAyQzE3LjUyMjggMiAyMiA2LjQ3NzE1IDIyIDEyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjguNDk3MDciIHk9IjcuNzIxOTIiIHdpZHRoPSIxLjciIGhlaWdodD0iOC41NTQ5MyIgcng9IjAuODUiIGZpbGw9IiNmZmZmZmYiLz4KPHJlY3QgeD0iMTMuODAyNyIgeT0iNy43MjE5MiIgd2lkdGg9IjEuNyIgaGVpZ2h0PSI4LjU1NDkzIiByeD0iMC44NSIgZmlsbD0iI2ZmZmZmZiIvPgo8L3N2Zz4K";